import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { BehaviorSubject } from 'rxjs';
@Component({
  selector: 'date-formated',
  templateUrl: './date-formated.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule, DateTimeFormatPipe
  ]
})
export class DateFormatedComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null);
  @Input() additionData = new BehaviorSubject(null);
  keyName!: string ;
  value!:number;
  format!:string;
  constructor() {}

  ngOnInit(): void {
  }

  getDate(date:any):Date{
    return new Date(date);
  }

  isEmptyAndNull(obj: any) {
    if (!obj)
      return true;
    else if (Object.keys(obj).length === 0) {
      return true;
    } else return false

  }

  hasValue(obj: any) {
    if (obj != null && obj != undefined)
      return true;
     else return false
  }

}